import React, { useEffect, useState } from "react";
import SourceFlowHead from "@sourceflow-uk/sourceflow-head";
import metaObject from "../../.sourceflow/metadata.json";

export default function SeoHead({
  site_name = "SRG",
  page_name = "Science, Engineering & Life Science Recruitment, Jobs & Staffing | SRG",
  description = "Discover career opportunities and industry insights with SRG, the Science, Engineering & Life Sciences recruitment specialists.",
  canonical_link = "",
  og_image = "https://www.srgtalent.com/site-assets/images/og-image.jpg",
  og_img_alt = "Science, Engineering & Life Science Recruitment, Jobs & Staffing | SRG",
  en_gb = true,
  en_us,
  robots = null,
}) {
  const canonical_url = `https://www.srgtalent.com${en_us ? "/us" : ""}${
    canonical_link ? "/" + canonical_link : ""
  }`;
  const alternate_url = `https://www.srgtalent.com${en_gb ? "/us" : ""}${
    canonical_link ? "/" + canonical_link : ""
  }`;

  // Check if 'alternate_url' page exist
  const [alternatePage, setAlternatePage] = useState(null);
  useEffect(() => {

    const https = require('https');
    
    function fetchPage(url) {
      return new Promise((resolve) => {
        https.get(url, (res) => {
          resolve(res.statusCode < 400);
        }).on('error', (e) => {
          resolve(false);
        });
      });
    }

    async function fetchAlternate() {
      const page = await fetchPage(alternate_url);
      setAlternatePage(page);
    }
    fetchAlternate();
  }, [alternate_url]);

  return (
    <>
      <SourceFlowHead
        metaObject={metaObject}
        siteName={site_name}
        title={page_name}
        description={description}
        locale={en_gb ? "en-GB" : en_us ? "en-US" : null}
        robots={robots}
        canonical={canonical_url}
        languageAlternates={alternatePage ? [
          {
            hrefLang: en_gb ? "en-US" : en_us ? "en-GB" : null,
            href: alternate_url,
          },
        ] : null}
        images={[
          {
            url: og_image,
            width: 1200,
            height: 600,
            alt: og_img_alt,
            type: "image/jpeg",
          },
        ]}
      />
    </>
  );
}
